import script from "./FeeTableAnimated.vue?vue&type=script&setup=true&lang=js"
export * from "./FeeTableAnimated.vue?vue&type=script&setup=true&lang=js"

import "./FeeTableAnimated.vue?vue&type=style&index=0&id=4f7b0e89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_typescript@7.0.2__webpack@5.111.0_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7b0e89"]])

export default __exports__